import { apiClient } from "./api";

export const adminSearchService = {
  adminSearchUsers({ page, limit = 10, ...params }) {
    const offset = (page - 1) * limit;

    const body = { ...params, limit, offset };
    return apiClient.request(`/api/admin/search/users`, {
      method: "POST",
      requireAuth: true,
      body,
    });
  },

  adminSearchUpdateUser({ id, data }) {
    if (!id) {
      throw new Error("User id is required");
    }

    return apiClient.request(`/api/admin/search/user/${id}`, {
      method: "PATCH",
      requireAuth: true,
      body: {
        data,
      },
    });
  },

  adminSearchUpdateSubscription({
    id,
    data,
    secondarySubType,
    updateFirebase = true,
  }) {
    if (!id) {
      throw new Error("Subscription id is required");
    }

    const body = { updateFirebase };
    if (data != null && Object.keys(data).length > 0) {
      body.data = data;
    }
    if (secondarySubType !== undefined && secondarySubType !== null) {
      body.secondarySubType =
        secondarySubType === "" ? "none" : String(secondarySubType);
    }

    return apiClient.request(`/api/admin/search/subscription/${id}`, {
      method: "PATCH",
      requireAuth: true,
      body,
    });
  },

  adminSearchUpdateInvite({ id, data }) {
    if (!id) {
      throw new Error("Invite id is required");
    }

    return apiClient.request(`/api/admin/search/invite/${id}`, {
      method: "PATCH",
      requireAuth: true,
      body: {
        data,
      },
    });
  },

  adminSearchUpdateSession({ id, data }) {
    if (!id) {
      throw new Error("Session id is required");
    }

    return apiClient.request(`/api/admin/search/session/${id}`, {
      method: "PATCH",
      requireAuth: true,
      body: {
        data,
      },
    });
  },

  adminSearchVideos({ page, limit = 10, ...params }) {
    const offset = (page - 1) * limit;

    const body = { ...params, limit, offset };

    return apiClient.request(`/api/admin/search/videos`, {
      method: "POST",
      requireAuth: true,
      body,
    });
  },

  adminSearchSessions({ page, limit = 10, ...params }) {
    const offset = (page - 1) * limit;

    const body = { ...params, limit, offset };

    return apiClient.request(`/api/admin/search/sessions`, {
      method: "POST",
      requireAuth: true,
      body,
    });
  },

  adminSearchSubscriptions({ page, limit = 10, ...params }) {
    const offset = (page - 1) * limit;

    const body = { ...params, limit, offset };

    return apiClient.request(`/api/admin/search/subscriptions`, {
      method: "POST",
      requireAuth: true,
      body,
    });
  },

  adminSearchInvites({ page, limit = 10, ...params }) {
    const offset = (page - 1) * limit;

    const body = { ...params, limit, offset };

    return apiClient.request(`/api/admin/search/invites`, {
      method: "POST",
      requireAuth: true,
      body,
    });
  },
};
